<template>
	<div>
		<b-img src="/images/importer/module-tail/tail.jpg"></b-img>
		<p>
			The Tail module is for setting up physics properties for your character's tail, which will allow it to collide with objects in the world and be animated by the game. If you plan to animate 
			your character's tail yourself, or set it up with Dynamic Bones, this module is not needed. You should rotate your character's tail bones into a "resting" pose before using this
			module or exporting the character, since the Tail module will assume this is the default desired orientation of the tail.
		</p>
        
		<b-img src="/images/importer/module-tail/tail-colliders.jpg"></b-img>
		<p>
			One thing to note is that your character's tail should have colliders set up for each of its joints, or else it will behave strangely and float around instead of being weighed down by gravity.
			As you can see from the snow leopard character in the Example scene, this can be done with simple Capsule Colliders attached to each joint.
		</p>
        
		<p>
			<span class="font-weight-bold">Tail Base / Tail Tip:</span> The Base should be the first bone in the tail, and the Tip should be the last. The Tail Tip must be a descendant of the Tail Base.
		</p>
        
		<p>
			<span class="font-weight-bold">Tail Stiffness:</span> The strength of the spring joints in each tail bone, which will try to rotate each joint back to the resting pose, either after colliding
			with an object or just when affected by gravity.
		</p>
        
		<p>
			<span class="font-weight-bold">Tail Curl:</span> This is a "target" rotation value that will be applied to each joint in the tail, causing it to curl in that direction. As noted in the
            <router-link :to="{name: 'tutorials', params: {tutorialName: 'RigRequirements'}}">Rig Requirements</router-link> tutorial, it's important for each bone in the tail to be oriented the same
			direction, or else changing this Curl value will cause the tail to kink up at odd angles - this is because the target rotation is expressed in each tail joint's local space.
		</p>

		<p>
            <span class="font-weight-bold">Set Up Tail Joints:</span> This button will add the actual physics joints to each bone in the tail, with the Tail Stiffness and Tail Curl values that have been
			set here. Whenever you need to make a change to these values, you should click the Set Up Tail Joints button again to apply them. It's best to run Play mode in order to test good Tail 
			Stiffness and Tail Curl values since you can see the tail's physics in action - but keep in mind that changes made during Play mode are not preserved after exiting it, and you'll need 
			to re-assign the value and click Set Up Tail Joints again in order to lock them in.
		</p>
	</div>
</template>

<script>
export default {
		name: 'TailModule',
}
</script>
